/*
 * $Id:: index.js 2021/02/26 06:09 otsolka
 *
 *        . * .
 *      * RRRR  *   Copyright (c) 2012-2021 EUIPO: European Intelectual
 *     .  RR  R  .  Property Organization (trademarks and designs).
 *     *  RRR    *
 *      . RR RR .   ALL RIGHTS RESERVED
 *       *. _ .*
 *
 *  The use and distribution of this software is under the restrictions exposed in 'license.txt'
 */

import React, { useState } from 'react';

import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import MoreVertIcon from '@material-ui/icons/MoreVert';

const VerticalMenu = ({ menuItems, actionButtonId = 'actionButton' }) => {
    const [anchorEl, setAnchorEl] = useState(null);

    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
        setAnchorEl(null);
    };

    const handleAction = (action) => {
        action();
        handleClose();
    };

    return (
        <>
            <IconButton id={actionButtonId} aria-label="more" aria-controls="long-menu" aria-haspopup="true" onClick={handleClick}>
                <MoreVertIcon />
            </IconButton>
            <Menu id="simple-menu" anchorEl={anchorEl} keepMounted open={Boolean(anchorEl)} onClose={handleClose}>
                {menuItems
                    .filter((menuItem) => typeof menuItem === 'object') // display only menuItems that is type of object, with label and action props
                    .map((menuItem, index) => (
                        <MenuItem id={`${actionButtonId}-option-${index}`} key={index} onClick={() => handleAction(menuItem.action)}>
                            {menuItem.label}
                        </MenuItem>
                    ))}
            </Menu>
        </>
    );
};

export default VerticalMenu;
